export default "__VITE_ASSET__DBkEq6oK__"